//@ts-check

/**@type {import('../types').DataType<import('./types').JourneyMapDataModel>} */
var JOURNEY_MAP_DATA_TYPE = {
  data: {
    itemUrl: '/backend/journeys/{id}/map',
    dataKey: 'journeyMap',
    idKeyProp: 'id'
  }
};
export default JOURNEY_MAP_DATA_TYPE;